import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Briefcase = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Briefcase' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M1,6 L23,6 L23,21 L1,21 L1,6 Z M6,6 L6,21 M18,6 L18,21 M8,6 L8,3 L16,3 L16,6' />
  </StyledIcon>
);
